<template>
    <div>
        <div class="card card-lg">
            <div class="grid has-xs-gutter">
                <div
                    v-for="productVariantGroup in productVariantGroups"
                    :key="productVariantGroup.id"
                    class="column w-1/3 md:w-1/5 mb-sm"
                >
                    <a
                        class="box-tab"
                        :class="{'is-active': activeProductVariantGroup === productVariantGroup}"
                        @click="toggleGroup(productVariantGroup)"
                    >
                        <h3>{{ productVariantGroup.name }}</h3>
                    </a>
                </div>
            </div>
            <div
                v-if="activeProductVariantGroup"
                class="mt-4xl"
            >
                <!-- eslint-disable vue/no-v-html -->
                <div v-html="activeProductVariantGroup.unique_selling_points" />
            </div>
        </div>
        <div class="mt-xl mb-2xl text-center">
            <button class="btn is-primary btn-md" @click="continueBtnClick">{{ continueBtnText }}</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            productVariantGroups: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                activeProductVariantGroup: null,
            };
        },
        computed: {
            continueBtnText() {
                return this.$isAnonymous ? lang('Sök adress', 'Search address') : lang('Beställ', 'Order');
            },
        },
        mounted() {
            this.activeProductVariantGroup = this.productVariantGroups[0];

            // If the first group is "10 Mbit", switch to next speed since we
            // generally don't want to front that speed
            if (this.productVariantGroups[1] && this.activeProductVariantGroup.name.includes('10 ')) {
                this.activeProductVariantGroup = this.productVariantGroups[1];
            }
        },
        methods: {
            toggleGroup(productVariantGroup) {
                if (this.activeProductVariantGroup === productVariantGroup) {
                    this.activeProductVariantGroup = null;
                    return;
                }

                this.activeProductVariantGroup = productVariantGroup;
            },
            continueBtnClick() {
                if (this.$isAnonymous) {
                    this.scrollItAndFocus('#address-search');
                } else {
                    this.scrollIt('.block-broadbandProducts', 'smooth', null, -120);
                }
            },
        },
    };
</script>
